angular.module('impactx.sidebar').controller('UserMenuCtrl', UserMenuCtrl);

UserMenuCtrl.$inject = ['$scope', 'TranslationService'];

function UserMenuCtrl($scope, TranslationService)
{
    $scope.$watch('importantItems', function(newVal, oldVal) {
        if(newVal && newVal != oldVal) {
            recalc();
        }
    });
    
    var isImportantItem = function(item) {
        return $scope.importantItems.filter(function(important) {
            return item.view === important.view;
        }).length > 0;
    };
    
    var getValidSubItems = function(item) {
        if (!!item.subitems) {
            return item.subitems.filter(function (subitem) {
                return !isImportantItem(subitem);
            });
        }
        return null;
    };
    
    var initGroupItems = function(itemsToShow) {
        $scope.groupItems = [];
        angular.forEach(itemsToShow, function(item) {
            var validSubItems = getValidSubItems(item);
            if (validSubItems && validSubItems.length > 0) {
                item.expandable = true;
                item.subitems = validSubItems;
                $scope.groupItems.push(item);
            }
        })
    };

    var initTopItems = function(itemsToShow) {
        $scope.otherMenuItem = null;
        var topItems = itemsToShow.filter(function(item) {
            return !item.subitems || item.subitems.length === 0;
        });
        if (topItems.length > 0)
        {
            $scope.otherMenuItem = {
                condition: null,
                expandable: true,
                id: 0,
                label: TranslationService.get('view_other_' + $scope.currentWorkspaceId),
                link: null,
                module: null,
                showOpen: false,
                showopen: false,
                subitems: topItems,
                view: 'other_' + $scope.currentWorkspaceId
            };
        }
        else {
            $scope.otherMenuItem = null;
        }
    };
    
    var recalc = function() {
        var itemsToShow = $scope.menuItems.filter(function(item) {
            return !isImportantItem(item);
        });
        initGroupItems(itemsToShow);
        initTopItems(itemsToShow);
    };
    recalc();
}